<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <div class="pro-detail">
      <div class="title">{{currentProduct.itemName}}
        <div>{{currentProduct.itemIntro}}</div>
      </div>
      <img :src="$img + currentProduct.img" class="pro-img">
    </div>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import sidebar from "../../components/sidebar";

  export default {
    name: "productDetail",
    data() {
      return {
        pageIndex: 6,
        currentProduct: {
          itemName:'',
          itemIntro:'',
          img:''
        },
      }
    },
    components: {
      navbar,sidebar
    },
    mounted() {
      const id = this.$route.query.id  //项目id
      // this.currentProduct.itemName = this.$route.query.itemName
      this.currentProduct.itemIntro = this.$route.query.itemIntro
      //请求接口
      this.$http.get('/api/item/img/list',{params:{itemId:id}}).then((res)=>{
        // console.log(res)
        this.currentProduct.img = res.data.rows[0].img
        this.currentProduct.itemName = res.data.rows[0].itemName
      })
    }
  }
</script>

<style scoped>
  .title {
    font-size: 40px;
    width: 70%;
    margin: 120px auto 50px;
  }
  .title div{
    font-size: 16px;
    margin-top: 30px;
    color: #768087;
    width: 90%;
    line-height: 180%;
    letter-spacing: 0.05em;
  }

  .pro-img {
    width: 70%;
    margin: 0 auto 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/productDetail.vue